import React from 'react';
import { ConnectedRouter } from 'connected-react-router';
import { Switch, Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { history } from '../../../redux/store';

import { asLoadable } from '../LoadableRoute';

import Error404 from '../../screens/Errors/404';

import PublicRoute from './components/PublicRoute';
import PrivateRoute from './components/PrivateRoute';

import * as Routes from './constants';
import { VENDOR_ROLE } from '../../../utils/roles';

// Put routes as loadable routes to avoid downloading a big JS file

const Dashboard = asLoadable(() => import('../../screens/Dashboard'), { showMenu: true });
const Accounts = asLoadable(() => import('../../screens/Accounts'));
const DownloadApp = asLoadable(() => import('../../screens/DownloadApp'));
const AcceptInvite = asLoadable(() => import('../../screens/AcceptInvite'), { showMenu: true });
const Products = asLoadable(() => import('../../screens/Products'), { showMenu: true });
const Collections = asLoadable(() => import('../../screens/Collections'), { showMenu: true });
const Manufacturers = asLoadable(() => import('../../screens/Manufacturers'), { showMenu: true });
const Vendors = asLoadable(() => import('../../screens/Vendors'), { showMenu: true });
const Catalog = asLoadable(() => import('../../screens/Catalog'), { showMenu: true });
const Collaborators = asLoadable(() => import('../../screens/Collaborators'), { showMenu: true });
const Profile = asLoadable(() => import('../../screens/Profile'), { showMenu: true });

// eslint-disable-next-line
const getHomeForUser = user => user.role === VENDOR_ROLE ? Catalog : Products;

function AppRoutes({ user }) {
  return (
    <ConnectedRouter history={history}>
      <Switch>
        <Route path={Routes.APP} component={DownloadApp} />
        <PublicRoute path={Routes.ACCOUNTS} component={Accounts} />
        <PublicRoute path={Routes.ACCEPT_INVITES} component={AcceptInvite} />
        <PrivateRoute path={Routes.PRODUCTS_HOME} component={Products} />
        <PrivateRoute path={Routes.COLLECTIONS_HOME} component={Collections} />
        <PrivateRoute path={Routes.MANUFACTURERS_HOME} component={Manufacturers} />
        <PrivateRoute path={Routes.VENDORS_HOME} component={Vendors} />
        <PrivateRoute path={Routes.CATALOG_HOME} component={Catalog} />
        <PrivateRoute path={Routes.COLLABORATORS_HOME} component={Collaborators} />
        <PrivateRoute path={Routes.PROFILE} component={Profile} />
        <PrivateRoute path={Routes.HOME} component={user ? getHomeForUser(user) : Dashboard} />
        <Route component={Error404} />
      </Switch>
    </ConnectedRouter>
  );
}

const mapStateToProps = state => ({
  user: state.auth.currentUser,
});

AppRoutes.propTypes = {
  // eslint-disable-next-line
  user: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(AppRoutes);



// WEBPACK FOOTER //
// ./src/app/components/Routes/index.js